// test1547
(1547 && 0);
